import {
  BRIEF_DATA_FIELDS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
  BRIEF_NOTIFICATIONS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { BUCKET_LIST_QUERY_KEY } from "@entities/bucket/lib/constants";
import {
  BRIEF_CAMPAIGN_FACETS_QUERY_KEY,
  BRIEF_CAMPAIGN_PENDING_REVIEW_QUERY_KEY,
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
} from "@entities/campaigns/lib/contsants";
import { useMutation } from "@shared/lib/hooks";
import {
  BriefNotificationActionType,
  IBulkActionRequest,
} from "@shared/lib/types/brief";
import {
  BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  makeBriefDeliverablesQueryKey,
} from "../constants";
import { BriefService } from "../services/brief.service";

export default function useBulkActions() {
  const {
    mutate: bulkActions,
    isLoading: isBulkActions,
    isSuccess: isBulkActionsSuccess,
    error: bulkActionsError,
  } = useMutation({
    mutationFn: (payload: IBulkActionRequest) =>
      BriefService.bulkActionsInfluencer(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      if (
        params.actionType === BriefNotificationActionType.attachDeliverables
      ) {
        c.invalidateQueries({
          queryKey: [
            ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
            "facets",
            params.briefId,
          ],
        });
        c.invalidateQueries({
          queryKey: makeBriefDeliverablesQueryKey(params.briefId),
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, params.briefId],
        });
      }
      if (params.actionType === BriefNotificationActionType.purchase) {
        c.invalidateQueries({
          queryKey: makeBriefDeliverablesQueryKey(params.briefId),
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [
            ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
            "facets",
            params.briefId,
          ],
        });
      }
      // const successData = data?.data?.filter((item) => item.status === "success");

      // handleSuccess(
      //   successData.map((item) => ({
      //     id: item.briefInfluencerId,
      //     briefInfluencer: item.briefInfluencer,
      //   }))
      // );
      if (
        params.actionType === BriefNotificationActionType.declineBrand ||
        params.actionType === BriefNotificationActionType.declineInfluencer ||
        params.actionType === BriefNotificationActionType.deleteInfluencer ||
        params.actionType === BriefNotificationActionType.assignPricingPoc ||
        params.actionType === BriefNotificationActionType.reallocatePricingPoc ||
        params.actionType === BriefNotificationActionType.removePricingPoc ||
        params.actionType === BriefNotificationActionType.skipConfirmation ||
        params.actionType === BriefNotificationActionType.resendConfirmation
      ) {
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        });
      }
      if (params.actionType === BriefNotificationActionType.setCustomColumns) {
        c.invalidateQueries({
          queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, params.briefId],
        });
      }
      if (
        params.actionType ===
        BriefNotificationActionType.setCustomColumnsOnCampaignInfluencer
      ) {
        c.invalidateQueries({
          queryKey: BRIEF_CAMPAIGNS_LIST_QUERY_KEY(params.briefId),
        });
      }
      if (
        params.actionType === BriefNotificationActionType.copyToAnotherBrief
      ) {
        // handleSuccess();
        c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
        c.invalidateQueries({
          queryKey: [...BRIEF_LIST_QUERY_KEY, params?.briefId],
        });
      }
      if (
        params.actionType === BriefNotificationActionType.analyzeCreator ||
        params.actionType === BriefNotificationActionType.reAnalyzeCreator ||
        params.actionType === BriefNotificationActionType.shortlist ||
        params.actionType === BriefNotificationActionType.unshortlist ||
        params.actionType ===
          BriefNotificationActionType.markPendingReviewAsSeen ||
        params.actionType === BriefNotificationActionType.addSocialMediaToBrief ||
        params.actionType === BriefNotificationActionType.editBriefInfluencer
      ) {
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [
            ...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
            "facets",
            params.briefId,
          ],
        });
        c.invalidateQueries({
          queryKey: BRIEF_CAMPAIGNS_LIST_QUERY_KEY(params.briefId),
        });
        c.invalidateQueries({
          queryKey: BRIEF_CAMPAIGN_PENDING_REVIEW_QUERY_KEY(params.briefId),
        });
      }
      if (params.actionType === BriefNotificationActionType.editBriefInfluencer) {
        c.invalidateQueries({
          queryKey: makeBriefDeliverablesQueryKey(params.briefId),
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, params.briefId],
        });
      }
      if (params.actionType === BriefNotificationActionType.addInfluencersToBucket) {
        c.invalidateQueries({ queryKey: BUCKET_LIST_QUERY_KEY });
      }
      if (
        params.actionType ===
          BriefNotificationActionType.attachBriefToCampaignInfluencerTask ||
        params.actionType ===
          BriefNotificationActionType.assignOperationsPocToCampaignInfluencer ||
        params.actionType ===
          BriefNotificationActionType.editOrAddScriptToCampaignInfluencerTask
      ) {
        c.invalidateQueries({
          queryKey: BRIEF_CAMPAIGNS_LIST_QUERY_KEY(params.briefId),
        });
        c.invalidateQueries({
          queryKey: BRIEF_CAMPAIGN_FACETS_QUERY_KEY(params.briefId),
        });
      }
      c.invalidateQueries({
        queryKey: BRIEF_NOTIFICATIONS_QUERY_KEY(params.briefId),
      });
    },
  });
  return {
    bulkActions,
    isBulkActions,
    isBulkActionsSuccess,
    bulkActionsError,
  };
}
